import { RouteConfig } from 'vue-router'

const routes: RouteConfig[] = [
	{
		path: 'bigfile',
		component: () => import(/* webpackChunkName: "bigfile" */ '@bigfile/Index.vue')
	},
]
export default routes
